/**
 * In this file, we create a React component
 * which incorporates components provided by Material-UI.
 */
import React from 'react';
import queryString from 'query-string';

import { WithLocalize } from '../../containers/I18nProvider';
import RequestLoginErrorMessage from '../../components/RequestLoginErrorMessage';
import ServiceApi from '../../services/ServiceApi';

import './style.scss';
import logo  from './image/logo.png'
import LoginForm from './LoginForm';

class Login extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.api = new ServiceApi(this);
    this.parameters = queryString.parse(props.location.search);

  }

  _validateParams() {
    if (!this.parameters.client_id || !this.parameters.redirect_uri || !this.parameters.response_type) {
      return false;
    }
    return true;
  }

  componentDidMount() {
    document.body.className = 'gig-body';
    document.title = 'login';
  }

  render() {
    const {translate} = this.props;

    return (
      <div className="gig-container">
       <header>
    <img className='gig-logo' src={logo} alt='gigacable'/>
 </header>
          <div className='gig-title'>Autenticación de usuarios</div>
          {
            this._validateParams()
            ? <LoginForm
                api={this.api}
                location={this.props.location}
              />
            : <RequestLoginErrorMessage
                onlyMessage={true}
                message={translate('RequestLoginErrorMessage')}
              />
          }
      </div>
    );
  }
}

export default WithLocalize(Login);
